import {IndividualExtendedModel} from '@spa/api';

import {Helper} from '../../../shared/classes';
import {FeatureEnum, PermissionsEnum} from '../../../shared/enums';
import {PermissionRuleInterface} from '../../../shared/interfaces';

import {PermissionRulesTrait} from '../traits';

/**
 * Where the operator UI shows the client's public profile picture: on the Documents tab of an individual client,
 * while Public Traders is switched on, to an operator who may edit trading accounts. The backend gates every
 * picture route on that right and answers 401 without it, so the UI neither renders nor reads without it.
 */
export class PublicProfilePictureRule {
    /** The right the backend checks on every picture route. */
    static readonly editPermissionRule: PermissionRuleInterface = PermissionRulesTrait.getEditTradingAccountPermissionRule();

    static isFeatureOn(): boolean {
        return Helper.isFeatureEnabled(FeatureEnum.PublicTraders);
    }

    /** The same check the permission directive makes: the rule's permissions, or the all-rights permission. */
    static canManage(userPermissions: string[] | null | undefined): boolean {
        const permissions = userPermissions || [];

        return Helper.getUnionStrategyPermissionsCheck(PublicProfilePictureRule.editPermissionRule.permissions, permissions)
            || permissions.indexOf(PermissionsEnum.CrmAllAll) >= 0;
    }

    static isAvailable(individual: IndividualExtendedModel | null | undefined, userPermissions: string[] | null | undefined): boolean {
        return PublicProfilePictureRule.isFeatureOn() && !!individual && PublicProfilePictureRule.canManage(userPermissions);
    }
}
